<template>
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-3" role="tab">
        <span class="m-1">Ganti Kata Sandi</span>
        <b-button v-b-toggle.accordion-5 variant="yellow" class="chevron">
            <span class="when-open">
                <b-icon icon="chevron-up" />
            </span>
            <span class="when-closed">
                <b-icon icon="chevron-down" />
            </span>
        </b-button>
    </b-card-header>

    <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <b-card-body>
            <b-card-text>
                <div class="container">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <b-form @submit.prevent="handleSubmit(updatePassword)">
                      <div class="row">
                          <div class="col">
                            <div class="alamat mt-3">
                                <label for="password">Kata Sandi Lama</label>
                                <br />
                                <ValidationProvider name="Password lama" rules="required" v-slot="{ errors }">
                                  <b-form-input type="password" v-model="old_password" placeholder="Masukan kata sandi lama"></b-form-input>
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </div>
                          </div>
                      </div>
                      <div class="row">
                          <div class="col">
                            <div class="alamat mt-3">
                                <label for="password">Kata Sandi Baru</label>
                                <br />
                                <ValidationProvider name="Password baru" rules="required|confirmed:confirmation|min:8" v-slot="{ errors }">
                                  <b-form-input type="password" v-model="new_password" placeholder="Masukan kata sandi baru"></b-form-input>
                                  <div class="row">
                                    <div class="col-3">
                                      <small>Kekuatan Password: </small>
                                    </div>
                                    <div class="col mr-4">
                                      <password v-model="new_password" :strength-meter-only="true" />
                                    </div>
                                  </div>
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </div>
                          </div>
                      </div>
                      <div class="row">
                          <div class="col">
                            <div class="alamat mt-3">
                                <label for="fname">Konfirmasi Kata Sandi Baru</label>
                                <br />
                                <ValidationProvider name="Konfirmasi Password" vid="confirmation" rules="required" v-slot="{ errors }">
                                  <b-form-input type="password" v-model="confirm_password" placeholder="Konfirmasi Kata Sandi Baru"></b-form-input>
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </div>
                          </div>
                      </div>

                      <div class="alamat mt-4 mb-3">
                          <button type="submit" class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0" >Update Kata Sandi</button>
                      </div>

                    </b-form>
                  </ValidationObserver>
                </div>
            </b-card-text>
        </b-card-body>
    </b-collapse>

    <!-- Update password confirmation modal -->
    <b-modal size="sm" v-model="confirmUpdatePasswordModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Apa anda yakin ?</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="confirmUpdatePassword">Ya</b-button>
        </div>
        <div class="col">
          <b-button class="mt-3" block @click="confirmUpdatePasswordModal = false">Tidak</b-button>
        </div>
      </div>
    </b-modal>

    <!-- Success modal for all confirmation  -->
    <b-modal size="sm" v-model="successModal" hide-footer hide-header>
      <div class="d-block text-center">
        <b-icon :icon="icon" animation="throb" :variant="iconColor" style="width: 120px; height: 120px;"></b-icon>
        <h3>{{ modalText }}</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="successModal = false">Tutup</b-button>
        </div>
      </div>
    </b-modal>
  </b-card>

</template>

<script>

import Password from 'vue-password-strength-meter'
import User from '../../api/user'

export default {
  'name': 'ChangePassword',
  components: {
    Password
  },
  data() {
    return {
      old_password: null,
      new_password: null,
      confirm_password: null,
      confirmUpdatePasswordModal: false,
      successModal: false,
      modalText: '',
      icon: '',
      iconColor: ''
    }
  },
  mounted() {
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    updatePassword() {
      this.confirmUpdatePasswordModal = true;
    },
    confirmUpdatePassword() {
      const data = {
        id: this.currentUser.info.id,
        old_password: this.old_password,
        new_password: this.new_password
      }

      User.updatePassword(data)
      .then(res => {
        if (res.data.meta.code == 200) {
          this.successModal = true
          this.confirmUpdatePasswordModal = false
          this.icon = 'check-circle'
          this.iconColor = 'success'
          this.modalText = 'Password berhasil diubah, silahkan login kembali untuk memastikan'
          this.old_password = ''
          this.new_password = ''
          this.confirm_password = ''
        } else if (res.data.meta.code == 401) {
          this.successModal = true
          this.confirmUpdatePasswordModal = false
          this.modalText = 'Password lama tidak benar!'
          this.icon = 'x-circle-fill'
          this.iconColor = 'danger'
          this.old_password = ''
          this.new_password = ''
          this.confirm_password = ''
        } else {
          console.log(res.data)
        }
      })
      .catch(err => console.log(err))
    }
  }
}
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/ChangePassword.vue